import { create } from 'zustand';

interface MainContentScrollState {
  showHorizontalScrollbar: boolean;
  setShowHorizontalScrollbar: (show: boolean) => void;
}

export const useMainContentScrollStore = create<MainContentScrollState>(
  (set) => ({
    showHorizontalScrollbar: false,
    setShowHorizontalScrollbar: (show) =>
      set({ showHorizontalScrollbar: show }),
  }),
);
